import { render, staticRenderFns } from "./PortfolioManagementTabComponent.vue?vue&type=template&id=7176a614&scoped=true&"
import script from "./PortfolioManagementTabComponent.vue?vue&type=script&lang=js&"
export * from "./PortfolioManagementTabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176a614",
  null
  
)

export default component.exports